import React, { ReactNode } from 'react';

export const TableBox = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-border bg-body p-4">
      {children}
    </div>
  );
};
